import axios from "../../js/project-axios.js"

const list = () => {
    return axios.get("/warningRule/list");
};

const add = warningRule => {
    return axios.post("/warningRule/add", warningRule);
};

export default {
    list,
    add
};